import { createAction } from '@reduxjs/toolkit';

/**
 * Вынесено из слайса отдельно, чтобы baseApi мог диспатчить разлогин,
 * не импортируя слайс (в старом фронте request.js и auth.js импортировали
 * друг друга по кругу — работало случайно, за счёт хойстинга webpack).
 */
export const sessionLoggedOut = createAction('session/loggedOut');

/** Вошли под другим пользователем через login_as. */
export const sessionImpersonated = createAction('session/impersonated');